interface ApplicationConfig {
  api: {
    root: string;
  };
  auth: {
    tenantName: string;
    appId: string;
    apiReadScope: string;
  };
}

interface WindowWithApplicationConfig extends Window {
  applicationConfig?: ApplicationConfig;
}

const getWindow = () => window as WindowWithApplicationConfig;

const validateNoTrailingSlashInUri = (uri: string | undefined): string => {
  if (uri === undefined) {
    throw new Error('URI is undefined');
  }
  return uri.endsWith('/')
    ? uri.slice(0, -1) // If it has a trailing /, remove it
    : uri; // No trailing slash is expected
};

let externalApplicationConfigRequestPointer: Promise<ApplicationConfig> | null = null;

// Get the external config
export const fetchApplicationConfig = async (): Promise<ApplicationConfig> => {
  if (externalApplicationConfigRequestPointer !== null) {
    // If we already have a request running, just return that
    return externalApplicationConfigRequestPointer;
  }

  if (getWindow().applicationConfig === undefined) {
    // Fetch the json file - all these steps are done in a promise to make it easier to wait
    // const externalApplicationConfigRequestStartTime = performance.now();
    const externalApplicationConfigRequest = fetch('/application-config.json', {
      method: 'GET',
    })
      .then(data => data.json() as unknown as ApplicationConfig)
      .then(externalApplicationConfig => {
        // Validate fields exist
        if (externalApplicationConfig.api === undefined) {
          console.error('externalApplicationConfig.api is undefined');
        }
        externalApplicationConfig.api.root = validateNoTrailingSlashInUri(
          window.location.protocol + '//' + window.location.host
        );
        if (externalApplicationConfig.auth === undefined) {
          console.error('externalApplicationConfig.auth is undefined');
        }
        if (externalApplicationConfig.auth.tenantName === undefined) {
          console.error('externalApplicationConfig.auth.tenantName is undefined');
        }
        if (externalApplicationConfig.auth.appId === undefined) {
          console.error('externalApplicationConfig.auth.appId is undefined');
        }
        if (externalApplicationConfig.auth.apiReadScope === undefined) {
          console.error('externalApplicationConfig.auth.apiReadScope is undefined');
        }

        // TODO Setup app insights
        // setupApplicationInsights(
        // 	getWindow().applicationConfig!.applicationInsightsInstrumentationKey
        // );
        // getAppInsights()?.trackEvent({
        // 	name: 'Configuration Loaded',
        // 	properties: { durationMs: performance.now() - externalApplicationConfigRequestStartTime },
        // });

        // Set the config and return it (this call validates getConfig will work later)
        getWindow().applicationConfig = externalApplicationConfig;
        return getConfig();
      });

    externalApplicationConfigRequestPointer = externalApplicationConfigRequest;

    // Wait before returning from this function call (window.applicationConfig will be populated while waiting)
    await externalApplicationConfigRequest;
  }

  return getWindow().applicationConfig!;
};

// Static config
export const getConfig = (): ApplicationConfig => {
  if (getWindow().applicationConfig === undefined) {
    throw new Error('Application config has not been loaded');
  }
  return getWindow().applicationConfig!;
};
